import Form from "./MessageForm";

export const MessageForm = Form;